import React from "react";
import { Column, Columns, Control, Field, Input } from "@allxsmith/bestax-bulma";


export default function NegativeFinanceSection({financeAgreement, onChange, index}){
    // Change depreciation formula if finance_type = NEGATIVE_FINANCE

    return (
        <div>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Amount</label>
                        <Control>
                            <Input
                                type={"number"}
                                name={"finance_amount_borrowed"}
                                value={financeAgreement.finance_amount_borrowed}
                                onChange={onChange}
                            />
                        </Control>
                    </Field>
                </Column>
            </Columns>
        </div>
    );


}